import {BaseContainerModel} from '../../base-container.model';

export class StatisticsEventExpensesReportsContainerModel extends BaseContainerModel {
  claim_status: string;
  total_count: number;
  total_amount: number;
}
